export default "__VITE_ASSET__BEFhkzqU__"